import React from "react";
import styles from "./styles.module.css";

const BotaoDeletar = ({onClick}) => {
    return (
        <button
            type="button"
            onClick={onClick}
            className={styles.botaoDeletar}
        >
            ×
        </button>
    );
}

export default BotaoDeletar;